import { useState } from "react";

const JohnDeereConnect = () => {
  const [popup, setPopup] = useState<Window | null>(null);
  const jdConnectSettings = {
    wellKnown: process.env.REACT_APP_JD_WELL_KNOWN,
    client_id: process.env.REACT_APP_JD_CLIENT_ID,
    callback_url: process.env.REACT_APP_JD_CALLBACK_URL,
    response_type: process.env.REACT_APP_JD_RESPONSE_TYPE,
    scope: process.env.REACT_APP_JD_SCOPE,
    state: process.env.REACT_APP_JD_STATE,
  };

  const connectPopup = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      console.log("POPUP");
      const metadata = await (await fetch(jdConnectSettings.wellKnown!)).json();
      const params = new URLSearchParams({
        client_id: jdConnectSettings.client_id!,
        redirect_uri: jdConnectSettings.callback_url!,
        response_type: jdConnectSettings.response_type!,
        scope: jdConnectSettings.scope!,
        state: jdConnectSettings.state!,
      });
      const url = `${metadata.authorization_endpoint}?${params.toString()}`

      const width = 500;
      const height = 700;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2.5;
      const title = `John Deere - Connect`;
      const popup = window.open(url, title, `width=${width},height=${height},left=${left},top=${top}`);
      setPopup(popup);
    } catch (error: unknown) {
      console.error("Error al obtener metadata de John Deere", error);
      return;
    }
    
    // const url = `https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/v1/authorize`;
  };

  return <>
    <button
      className="btn btn-primary btn-rounded btn-block"
      type="button"
      onClick={(event) => connectPopup(event)}
    >
      Conectar API
    </button>
  </>
};

export default JohnDeereConnect;